import type { RootState } from '@/store';
import { createSelector, createSlice } from '@reduxjs/toolkit';

export const GUILD_FEATURE_KEY = 'guild';

interface GuildState {
  joinModal: {
    show: boolean;
    guildName?: string | null;
    guildId?: string | null;
  };
}

const initialState: GuildState = {
  joinModal: {
    show: false,
    guildId: null,
  },
};

const slice = createSlice({
  name: GUILD_FEATURE_KEY,
  initialState,
  reducers: {
    setJoinModal: (state, { payload }) => {
      state.joinModal = payload;
    },
    toggleJoinModal: (state) => {
      state.joinModal.show = !state.joinModal.show;
    },
  },
  extraReducers: (builder) => {
    // TODO
  },
});

const guildActions = slice.actions;
const guildReducer = slice.reducer;

const guildState = (state: RootState): typeof initialState => state.guild;

const selectJoinModal = createSelector(guildState, (guild) => guild.joinModal);

export { guildActions, guildReducer, selectJoinModal };
export default slice;
